import { SelectOption } from '@/components';
import { capitalizeFirst } from './capitalize-first';

export const enumToSelectOptions = <T extends Record<string, string>>(
  enumObject: T,
  labelTransform?: (value: string) => string,
): SelectOption[] => {
  return Object.values(enumObject).map((value) => ({
    label: labelTransform ? labelTransform(value) : capitalizeFirst(value),
    value,
  }));
};
